import { DOCUMENT, Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class NavigationSidebarService {
    private router = inject(Router);
    private document = inject<Document>(DOCUMENT);

    private status = new BehaviorSubject(false);
    isOpen: Observable<boolean>;
    constructor() {
        this.isOpen = this.status.pipe(
            distinctUntilChanged(),
            tap(isOpen => {
                if (isOpen) {
                    this.document.body.classList.add('overflow-hidden');
                } else {
                    this.document.body.classList.remove('overflow-hidden');
                }
            })
        );
        this.router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe(() => {
                this.close();
            });
    }

    close() {
        this.status.next(false);
    }

    open() {
        this.status.next(true);
    }

    toggle() {
        this.status.next(!this.status.value);
    }
}
